module.exports = __webpack_public_path__ + "img/storage04.ee24d940.jpg";